import { Progress as ChakraProgress } from '@chakra-ui/react';
import * as React from 'react';

interface ProgressProps extends ChakraProgress.RootProps {
  valueText?: React.ReactNode;
  label?: React.ReactNode;
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  function Progress(props, ref) {
    const { valueText, label, ...rest } = props;
    return (
      <ChakraProgress.Root {...rest} ref={ref}>
        {label && <ChakraProgress.Label>{label}</ChakraProgress.Label>}
        <ChakraProgress.Track>
          <ChakraProgress.Range />
        </ChakraProgress.Track>
        {valueText && (
          <ChakraProgress.ValueText>{valueText}</ChakraProgress.ValueText>
        )}
      </ChakraProgress.Root>
    );
  }
);
